// import cimg1 from '../../images/Case-studies/Criminal law.jpg'
// import cimg2 from '../../images/Case-studies/Family Law.jpg'
// import cimg3 from '../../images/Case-studies/Real Estate Law.jpg'
// import cimg4 from '../../images/Case-studies/Business Laws.jpg'



const Cases = [
    {
        Id: '1',
        cTitle: 'Criminal Law', 
        slug: 'Criminal-Law',
        // cImg:cimg1,
    },
    {
        Id: '2',
        cTitle: 'Family Law', 
        slug: 'Family-Law',
        // cImg:cimg2,
    },
    {
        Id: '3',
        cTitle: 'Real Estate', 
        slug: 'Real-Estate',
        // cImg:cimg3,
    },
    {
        Id: '4',
        cTitle: 'Business Law', 
        slug: 'Business-Law',
        // cImg:cimg4,
    },
]

export default Cases;